// This file is intended for any JS code that is required during front end design
// before the page-specific app is setup.
//
// This code should be refactored and moved to modules/widgets once the page-specific
// JS application is developed

// Imports the ion rangeslider for the car search filters
import $ from 'jquery';
import 'ion-rangeslider/css/ion.rangeSlider.css';
import 'ion-rangeslider/js/ion.rangeSlider.js';

$(function() {
    console.log("Frontend JS code executed here")
    $(".cars-range-slider").ionRangeSlider({
        min: 0,
        max: 200000,
        from: 10000,
        to: 50000,
        type: 'integer',
        postfix: " miles",
        grid: true,
        grid_num: 10,
        hide_min_max: true,
        decorate_both: false
    });
});